import { HttpClient } from 'api/helpers/HttpClient';
import { apiCall } from '../..';
import {
  PAYWAY_PROFILE_PATH_SERVICE,
  PURCHASE_BUTTON_INFO_SERVICE,
  USER_SUSPENDED_PATH_SERVICE,
} from './paths';
import { module_version } from '../content/module_version';

export const userSuspendedService = async () => {
  return await apiCall.get(USER_SUSPENDED_PATH_SERVICE);
};

export const purchaseButtonInfoService = async params => {
  const { claroAdEnable, ...restParams } = params;
  const apiCall = new HttpClient({ hasClaroAdActive: claroAdEnable });
  const url = claroAdEnable
    ? PURCHASE_BUTTON_INFO_SERVICE
    : '/services/payway/purchasebuttoninfo';

  return await apiCall.get(url, {
    ...restParams,
    api_version: claroAdEnable ? null : 'v5.93',
  });
};

export const purchaseButtonInfoServiceV2 = async params => {
  const url = PURCHASE_BUTTON_INFO_SERVICE;

  return await apiCall.get(url, {
    params: { ...params, api_version: null },
  });
};

export const getPaywayProfileService = async (userToken = '') => {
  return await apiCall.get(PAYWAY_PROFILE_PATH_SERVICE, {
    params: { module_version },
  });
};
